import React, { useContext } from 'react';
import styled from 'styled-components';

import { Typography, Button } from 'antd';
import { Table, ApplicationUIContext } from '@yuhuinc/ui-library';
import { DeleteOutlined } from '@ant-design/icons';
import { getTranslatedString } from 'helpers/i18n';
import { formatMoney } from 'helpers/Formatter';

const { Title } = Typography;

const StyledButton = styled(Button)`
  margin-top: 12px;
`;

const ListParking = ({
  selectedAncillaryItems,
  setAddParking,
  removeAncillaryItem,
  formMaxInstances,
}) => {
  const { isMobile } = useContext(ApplicationUIContext);

  const columns = [
    {
      title: getTranslatedString('tenantPortal.application.parking.space'),
      dataIndex: 'asset_number',
    },
    {
      title: getTranslatedString('tenantPortal.application.parking.monthly'),
      dataIndex: 'market_amount',
      render: (text) => formatMoney(text),
    },
    {
      title: getTranslatedString('tenantPortal.application.parking.deposit'),
      dataIndex: 'market_deposit_amount',
      render: (text) => formatMoney(text),
    },
    {
      key: 'actions',
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<DeleteOutlined />}
            onClick={() => removeAncillaryItem(record)}
          />
        </>
      ),
      width: '20%',
    },
  ];

  return (
    <>
      {selectedAncillaryItems?.length !== 0 && (
        <>
          <Title level={5}>
            {getTranslatedString('tenantPortal.application.parking.yourSpaces')}
          </Title>
          <Table
            dataSource={selectedAncillaryItems}
            columns={columns}
            hideActionAndSearch
            size={isMobile ? 'middle' : 'small'}
            scroll={{
              x: isMobile,
            }}
            pagination={false}
          />
        </>
      )}
      {selectedAncillaryItems.length < formMaxInstances && (
        <StyledButton onClick={setAddParking}>
          {getTranslatedString('tenantPortal.application.parking.addParking')}
        </StyledButton>
      )}
    </>
  );
};

export default ListParking;
